import React from 'react';

require('./wave.css');

const wavesIntro = {
  position: 'relative',
  overflow: 'hidden',
  width: '100%',
  marginTop: '-4rem',
};

const wavesWrapper = {
  position: 'relative',
  overflow: 'hidden',
  width: '100%',
  height: '124px',
  transform: 'rotate(180deg)',
};

const waves = {
  position: 'absolute',
  top: '40px',
  width: 'calc(100% + 400px)',
  margin: '0 0 0 -200px',
};

const svg = {
  fill: 'currentColor',
};

const svgPathOne = {
  opacity: '.4',
  animation: '14s ease-in-out infinite alternate waveAnimateB',
};

const svgPathTwo = {
  opacity: '.4',
  animation: '14s ease-in-out infinite alternate waveAnimateA',
};

const svgPathThree = {
  opacity: '.4',
  animation: '14s ease-in-out infinite alternate waveAnimateC',
};

const Wave = () => (
  <div style={wavesIntro}>
    <div style={wavesWrapper}>
      <div style={waves}>
        <svg viewBox="0 0 800 600" style={svg}>
          <defs>
            <linearGradient
              x1="0%"
              y1="0%"
              x2="101.999998%"
              y2="100.999999%"
              id="linearGradient-1"
            >
              <stop stopColor="#3023AE" offset="0%" />
              <stop stopColor="#C96DD8" offset="100%" />
            </linearGradient>
            <linearGradient
              x1="0.25781251%"
              y1="49.7500002%"
              x2="101.257813%"
              y2="49.7500002%"
              id="linearGradient-2"
            >
              <stop stopColor="#3023AE" offset="0%" />
              <stop stopColor="#53A0FE" offset="47.5247532%" />
              <stop stopColor="#B4ED50" offset="100%" />
            </linearGradient>
          </defs>
          <path
            style={svgPathOne}
            d="M0,13 C66.6666667,-3.66666667 133.333333,-3.66666667 200,13 C266.666667,29.6666667 333.333333,29.6666667 400,13 C466.666667,-3.66666667 533.333333,-3.66666667 600,13 C666.666667,29.6666667 733.333333,29.6666667 800,13 L800,563 L0,563 L0,13 Z"
            id="Shape01"
            fill="#E8EDFA"
          />
          <path
            style={svgPathTwo}
            d="M0,13 C66.6666667,-3.66666667 133.333333,-3.66666667 200,13 C266.666667,29.6666667 333.333333,29.6666667 400,13 C466.666667,-3.66666667 533.333333,-3.66666667 600,13 C666.666667,29.6666667 733.333333,29.6666667 800,13 L800,563 L0,563 L0,13 Z"
            id="Shape02"
            fillOpacity="0.100000001"
            fill="url(#linearGradient-1)"
          />
          <path
            style={svgPathThree}
            d="M0,13 C66.6666667,-3.66666667 133.333333,-3.66666667 200,13 C266.666667,29.6666667 333.333333,29.6666667 400,13 C466.666667,-3.66666667 533.333333,-3.66666667 600,13 C666.666667,29.6666667 733.333333,29.6666667 800,13 L800,563 L0,563 L0,13 Z"
            id="Shape03"
            fillOpacity="0.200000003"
            fill="url(#linearGradient-2)"
          />
        </svg>
      </div>
    </div>
  </div>
);

export default Wave;
